import { render } from "./ForumWorkspace.vue?vue&type=template&id=3ad838e8&scoped=true"
import script from "./ForumWorkspace.vue?vue&type=script&lang=js"
export * from "./ForumWorkspace.vue?vue&type=script&lang=js"

import "./ForumWorkspace.vue?vue&type=style&index=0&id=3ad838e8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ad838e8"]])

export default __exports__